import { render } from "./Buildings.vue?vue&type=template&id=76c9fa0c&scoped=true"
import script from "./Buildings.vue?vue&type=script&lang=js"
export * from "./Buildings.vue?vue&type=script&lang=js"

import "./Buildings.vue?vue&type=style&index=0&id=76c9fa0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c9fa0c"]])

export default __exports__